export default "__VITE_ASSET__41c65caa__"